<app-navbar-style-three></app-navbar-style-three>

<app-pantalla-desafio *ngIf="dividirPantalla === 'Desafio'"></app-pantalla-desafio>
<app-pantalla-giro *ngIf="dividirPantalla === 'Giro'"></app-pantalla-giro>
<app-pantalla-categoria *ngIf="dividirPantalla === 'Categoria'"></app-pantalla-categoria>